import VuexPersistence from 'vuex-persist';
import { STORAGE_VUEX_ARTIST_STOCK_UPLOAD_KEY } from '@/artist.constants.js';

export default new VuexPersistence({
  key: STORAGE_VUEX_ARTIST_STOCK_UPLOAD_KEY,
  storage: window.sessionStorage,
  modules: ['artistElementUpload'],
});
